<template>
  <div class="yxtbiz-rule-cycle">
    <yxt-radio-group v-model="formData.ruleCycle" @change="onChange">
      <yxt-radio v-for="item in typeOps" :key="item.value" :label="item.value">{{ item.label }}</yxt-radio>
    </yxt-radio-group>
    <div v-if="showTimes" class="mt16">
      <span>{{ $t('pc_biz_rule_cycle_valid_times' /*'周期内最多生效'*/) }}</span>
      <yxt-input-number class="mh8" v-model="formData.cycleTimes" :precision="0" :min="1"></yxt-input-number>
      <span>{{ $t('pc_biz_rule_cycle_times' /*'次'*/) }}</span>
    </div>
  </div>
</template>

<script>
import { getRuleBaseInfo } from './service';
export default {
  name: 'YxtbizRuleCycle',
  props: {
    // 业务编号
    businessCode: {
      type: String,
      default: ''
    },
    // 模块编号
    moduleCode: {
      type: String,
      default: ''
    },
    // 规则编号
    ruleCode: {
      type: String,
      default: ''
    },
    // 使用平台 op-运营平台
    platformType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {
        ruleCycle: 1,
        cycleTimes: 1
      },
      typeOps: [
        { label: this.$t('pc_biz_rule_everyday' /* '每天' */), value: 1 },
        { label: this.$t('pc_biz_rule_count_by_times' /* '计次' */), value: 2 },
        { label: this.$t('pc_biz_rule_not_limit' /* '无限制' */), value: 3 }
      ],
      showTimes: true
    };
  },
  watch: {
    'formData': {
      handler(val) {
        this.$emit('change', val);
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getRuleInfo();
  },
  methods: {
    /**
     * 获取已有的规则信息
     */
    getRuleInfo() {
      if (!this.ruleCode) {
        return;
      }
      getRuleBaseInfo(this.ruleCode, this.platformType).then(res => {
        this.formData = res;
      });
    },
    onChange(val) {
      this.showTimes = val !== 3;
      this.formData.cycleTimes = 1;
    }
  }
};
</script>
